module.exports = __webpack_public_path__ + "static/media/easy.909cbd7a.png";